// Externals
import React from "react";
import { useSelector } from "react-redux";

import Header from "../components/Header";
import Header2 from "../components/Header2";
import PetProfileCard from "../components/PetProfileCard";
import Floor from "../components/Floor/Floor";

import "./Matches.scss";

const Matches = () /*: React.Component */ => {
	const userName = useSelector((state) => state.answers[1]?.answer[0]?.text);

	const matches = useSelector((state) => state.matches?.matches);

	return (
		<div className="match-screen">
			<Header />
			<Header2 />
			<div className="match-screen-container">
				<div className="match-screen-content">
					<div className="greeting">
						<div className="heading">
							{userName && userName}, meet your matches
						</div>
						<div>
							Even if we do find a suitable dog for you, we can't
							guarantee you'll be able to take that exact pet
							home. Standard RSPCA NSW adoption procedures still
							apply so pop down to one of our shelters for a meet
							and greet, and we'll go from there.
						</div>
					</div>
					<div className="results">
						{matches && matches.length && console.log(matches)}
						{matches &&
							matches.length &&
							matches.map((match, i) => (
								<PetProfileCard
									key={match.id}
									props={match}
									storeId={i}
								/>
							))}
					</div>
				</div>
				<Floor id={5} />
			</div>
		</div>
	);
};

// Exports
export default Matches;
